import { langId } from "../languages"

const socialConfig = [
  {
    url: "https://www.linkedin.com/company/linkreit/",
    name: langId.LINKEDIN,
    img: "/svg/linkedin.svg",
    key: "linkedin",
  },
  {
    url: "https://twitter.com/LINKREITHK",
    name: langId.TWITTER,
    img: "/svg/twitter.svg",
    key: "twitter",
  },
  {
    url: "https://www.facebook.com/LinkTogetherInitiatives/",
    name: langId.FACEBOOK,
    img: "/svg/facebook.svg",
    key: "facebook",
  },
  {
    url: "https://www.instagram.com/linkreithk/",
    name: langId.INSTAGRAM,
    img: "/svg/instagram.svg",
    key: "instagram",
  },
  {
    url: "https://www.youtube.com/channel/UCHdr0VcULlYn3vHRv36H9ww",
    name: langId.YOUTUBE,
    img: "/svg/youtube.svg",
    key: "youtube",
  },
  {
    url: "https://weibo.com/u/7375947872",
    name: langId.WEIBO,
    img: "/svg/weibo.svg",
    key: "weibo",
  },
  {
    url: "https://www.linkreit.com/sc/follow-linkreit-wechat/",
    name: langId.WECHAT,
    img: "/svg/wechat.svg",
    key: "wechat",
  },
]

export default socialConfig
